import script from "./ProgramVersionDesignLayersForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProgramVersionDesignLayersForm.vue?vue&type=script&setup=true&lang=ts"

import "./ProgramVersionDesignLayersForm.vue?vue&type=style&index=0&id=3d0fabbf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d0fabbf"]])

export default __exports__